// extracted by mini-css-extract-plugin
export default {"external":"aqMy5O","iconWrapper":"bqMy5O"};